import { HEARTBEAT_FILE, SOUND_CLIPS, type SoundClipId } from "@puszczyk/sounds";

// Recorded announcements present in packages/sounds/clips (ADR-0015). Vite lists the files at
// build time, so a clip the owner has not generated yet is simply absent and only the tone plays.
const urls = import.meta.glob<string>("../../../../../packages/sounds/clips/*.mp3", {
  eager: true,
  query: "?url",
  import: "default",
});

function fileUrl(file: string): string | undefined {
  return Object.entries(urls).find(([path]) => path.endsWith(`/${file}`))?.[1];
}

export function clipUrl(id: SoundClipId): string | undefined {
  return fileUrl(SOUND_CLIPS[id].file);
}

/** The "Ratun działa" chime, the same file as on the phone (issue #87). */
export const HEARTBEAT_URL = fileUrl(HEARTBEAT_FILE);
